import { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '@/core/stores/authStore';
import { getDefaultPortalPath } from '@/features/auth/components/RoleGuard';

export default function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login, isLoading } = useAuthStore();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await login(email, password);

      // Get user from store and redirect to appropriate portal
      const user = useAuthStore.getState().user;
      const from = (location.state as any)?.from?.pathname;

      if (from) {
        navigate(from, { replace: true });
      } else if (user) {
        navigate(getDefaultPortalPath(user.role), { replace: true });
      } else {
        navigate('/family/dashboard', { replace: true });
      }
    } catch (err: any) {
      setError(err.response?.data?.detail || 'Invalid credentials');
    }
  };

  return (
    <div className="bg-white rounded-xl p-8 shadow-lifted">
      <h1 className="font-display text-heading-lg text-center mb-2">Welcome back</h1>
      <p className="text-center text-warm-gray mb-8">Sign in to your account</p>

      {error && (
        <div className="mb-4 p-3 bg-error/10 border border-error/20 rounded-md text-error text-sm">
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label htmlFor="email" className="block text-sm font-medium text-navy mb-1">
            Email
          </label>
          <input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="input"
            placeholder="you@example.com"
            required
          />
        </div>

        <div>
          <label htmlFor="password" className="block text-sm font-medium text-navy mb-1">
            Password
          </label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="input"
            placeholder="••••••••"
            required
          />
        </div>

        <div className="flex items-center justify-between text-sm">
          <label className="flex items-center gap-2">
            <input type="checkbox" className="rounded border-warm-gray/30" />
            <span className="text-navy">Remember me</span>
          </label>
          <Link to="/forgot-password" className="text-sage hover:text-sage-dark">
            Forgot password?
          </Link>
        </div>

        <button type="submit" className="btn-primary w-full justify-center" disabled={isLoading}>
          {isLoading ? 'Signing in...' : 'Sign in'}
        </button>
      </form>

      <p className="mt-6 text-center text-sm text-warm-gray">
        Don't have an account?{' '}
        <Link to="/register" className="text-sage font-medium hover:text-sage-dark">
          Sign up
        </Link>
      </p>
    </div>
  );
}

